import React from "react";
import styled from "styled-components";
import { down } from "styled-breakpoints";
import settings from "@src/settings";
import { useWindowSize } from "@src/utils/useWindowSize";

interface Props {
	direction: "prev" | "next";
	onClick: () => void;
	className?: string;
}
const Frame = styled.button<{
	direction: Props["direction"];
}>`
	display: flex;
	align-items: center;
	justify-content: ${(props) =>
		props.direction == "next" ? "flex-end" : "flex-start"};
	padding: 0 3rem;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	& > svg {
		transform: ${(props) =>
			props.direction == "prev" ? "rotate(0deg)" : "rotate(180deg)"};
	}
	${down("md")} {
		padding: 0;
		justify-content: center;
	}
`;

const Nav: React.FC<Props> = (props) => {
	const { direction, onClick, className } = props;
	const { width: windowW } = useWindowSize();
	return (
		<Frame className={className} direction={direction} onClick={onClick}>
			{windowW == null || windowW >= settings.breakpoint.sm ? (
				<svg width="29" height="45">
					<path
						d="M 24.5 5 L 6.5 22.5 L 24.5 40.5"
						fill="transparent"
						strokeWidth="9"
						stroke="rgb(26,48,129)"
						strokeMiterlimit="10"
					></path>
				</svg>
			) : (
				<svg width="17" height="26">
					<path
						d="M 14.362 2.889 L 3.81 13 L 14.362 23.4"
						fill="transparent"
						strokeWidth="5.28"
						stroke="rgb(26,48,129)"
						strokeMiterlimit="10"
					></path>
				</svg>
			)}
		</Frame>
	);
};

export default styled(Nav)``;
